
<template>
    <div class="table-body">
        <!-- 操作按钮 -->
        <div class="opt-btn">
            <el-button size="small" type="primary" v-if="hasBtnPermission('btn_supervise_add')" icon="el-icon-plus" @click="routerAdd">新增</el-button>
        </div>

        <!-- 表格数据 -->
        <el-table  :data="sendList" class="table-content" row-key="id" v-loading="dataListLoading" :header-cell-style="this.$globalGrayTableHeaderStyle" ref="multipleTable"  stripe border @selection-change="handleSelectionChange" 
            @filter-change="filterChange"
            @sort-change="sortChange">
            <el-table-column fixed type="index" align="center" label="序号" width="60" :index="getRowsIndex"></el-table-column>
            <el-table-column fixed type="selection" align="center" :reserve-selection="true"></el-table-column>

            <el-table-column fixed column-key="statusCondition" label="发送状态" prop='status' align="center" width="90px" :show-overflow-tooltip='true'
            :filters="[{ text: '待发送', value: -1 },{ text: '已发送', value: 0 },{ text: '已撤回', value: 1 }]">
                <template slot-scope="scope">
                    <i :class="formatterStatusClass(scope.row.status)"></i>
                    <span>{{formatterStatusName(scope.row.status)}}</span>
                </template>
            </el-table-column>

            <el-table-column fixed label="督办标题" prop='title' header-align="left" align="left" min-width='300' >
                <template slot-scope="scope">
                    <div class="row-overflow">{{scope.row.title}}</div>
                </template>
            </el-table-column>
            <el-table-column label="督办部门" prop='deptName'  align="left" width='200' :show-overflow-tooltip='true'>
                <template slot="header" slot-scope="scope">
                    <div class="custom-header" style="justify-content:start;">
                        <span>督办部门</span>
                        <el-popover width="300" trigger="click">
                            <div class="custom-section">
                                <p>请输入</p>
                                <el-input v-model="queryData.filter.deptName" clearable></el-input>
                                <div class="custom-section--btns">
                                    <el-button size="mini" type="text" @click="cancelFilter">取消</el-button>
                                    <el-button size="mini" type="primary" @click="filterHandler">确定</el-button>
                                </div>
                            </div>
                            <i slot="reference" class="el-icon-search"></i>
                        </el-popover>
                    </div>
                </template>
            </el-table-column>

            <el-table-column label="督办时间" prop='inspectorTime' align="center" width='180' :show-overflow-tooltip='true'>
                <template slot-scope="scope">
                    <span>{{scope.row.inspectorTime}}</span>
                </template>
            </el-table-column>

            <el-table-column label="督办对象" prop='inspectorObjects' align="left" width='300' :show-overflow-tooltip='true'>
                <template slot="header" slot-scope="scope">
                    <div class="custom-header">
                        <span>督办对象</span>
                        <el-popover width="300" trigger="click">
                            <div class="custom-section">
                                <p>请输入</p>
                                <el-input v-model="queryData.filter.inspectorObjects" clearable></el-input>
                                <div class="custom-section--btns">
                                    <el-button size="mini" type="text" @click="cancelFilter">取消</el-button>
                                    <el-button size="mini" type="primary" @click="filterHandler">确定</el-button>
                                </div>
                            </div>
                            <i slot="reference" class="el-icon-search"></i>
                        </el-popover>
                    </div>
                </template>
            </el-table-column>

            <el-table-column column-key="replyStatusCondition" label="回复状态" prop='replyStatus' align="center" width='100' :show-overflow-tooltip='true'
            :filters="[{ text: '未回复', value: 0 },{ text: '已回复', value: 1 }, { text: '部分回复', value: -1 }]">
                <template slot-scope="scope">
                    <el-tag v-if="scope.row.replyStatusName == '部分回复'">{{scope.row.replyStatusName}}</el-tag>
                    <el-tag type="success" v-else-if="scope.row.replyStatusName == '已回复'">{{scope.row.replyStatusName}}</el-tag>
                    <el-tag type="danger" v-else>{{scope.row.replyStatusName}}</el-tag>
                </template>
            </el-table-column>

            <el-table-column label="回复时间" prop='replyTime' align="center" width='180' :show-overflow-tooltip='true' :sortable="true">
                <template slot-scope="scope">
                    <span>{{scope.row.replyTime}}</span>
                </template>
            </el-table-column>

            <el-table-column label="回复内容" prop='replyContent' header-align="left" align="left" width='200' :show-overflow-tooltip='true'>
                <!-- <template slot="header" >
                    <div class="custom-header"><span>回复内容</span></div>
                </template> -->
            </el-table-column>
            <el-table-column label="创建人" prop='createUser' align="center" width='200' :show-overflow-tooltip='true'></el-table-column>

            <el-table-column label="创建时间" prop='createTime' align="center" width='180' :show-overflow-tooltip='true' :sortable="true">
                <template slot-scope="scope">
                    <span>{{scope.row.createTime}}</span>
                </template>
            </el-table-column>

            <el-table-column label="操作" fixed="right" align="center" width="100">
                <template slot-scope="scope">
                    <el-button type="text" size="small"  @click="viewDetail(scope.row)" v-if="hasBtnPermission('btn_supervise_view')">查看</el-button>
                    <el-button type="text" v-if="scope.row.status == 0&&hasBtnPermission('btn_supervise_recall')" size="small" @click="withdrawHandler(scope.row)">撤回</el-button>
                    <el-button type="text" v-if="scope.row.status != 0&&hasBtnPermission('btn_supervise_delete')" size="small" @click="deleteHandler(scope.row)">删除</el-button>
                </template>
            </el-table-column>
        </el-table>

        <!-- 分页 -->
        <el-pagination background
            layout="total, sizes, prev, pager, next"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="queryData.rows"
            :total="total"
            :current-page="queryData.page"
            @size-change="sizeChangeHandle"
            @current-change="currentChangeHandle">
        </el-pagination>
    </div>

</template>

<script>
import { mapState } from "vuex";

export default {
    props: {
        keyword: {
            type: String,
            default: ''
        },
        tradeId:{
            type: String,
            default: ''
        }
    },
    data() {
        return {
            multipleSelection:[],
            pageSize: 10,//每页条数
            pageIndex: 1,//当前页

            // 加载状态
            dataListLoading: false,
            filterPopoverVisible: false,

            tableMaxHeight: document.documentElement.clientHeight - 347,


            // 查询参数对象
            queryData: {
                page: 1,
                rows: 10,
                orderBy: '',
                searchKey: '',
                filter: {
                    searchType:0,
                    deptName: '',
                    inspectorObjects: ''
                },
            },

            // 列表数据
            sendList: [],
            total: 0,

        };
    },
    watch: {
        keyword (newVal) {
            this.resetData();
            this.queryData.searchKey = newVal;
            this.getSendList();
        },
        uerdefultOptionCode:{
        handler (val,oldVal){
          if(val.length!==0){
            this.getSendList();
          }
        }
    }
    },

    computed: {
    ...mapState({
      uerdefultOptionCode: state => state.dataDictionary.uerdefultOptionCode,
    })
  },
    created() {
        if (this.keyword) {
            this.queryData.searchKey = this.keyword;
        }
        this.getSendList();
    },
    methods: {
        handleSelectionChange(val){
            this.multipleSelection = val;
        },

        formatterStatusClass(historyId){
            switch(historyId){
                case -1: return 'icon-point icon-point-verificationing'; break;
                case 0: return 'icon-point icon-point-success'; break;
                case 1: return 'icon-point icon-point-info'; break;
                default:return ''; break;
            }
        },

        formatterStatusName(historyId){
            switch(historyId){
                case -1: return '待发送'; break;
                case 0: return '已发送'; break;
                case 1: return '已撤回'; break;
                default:return ''; break;
            }
        },
        getRowsIndex(index) {
            return (this.pageIndex - 1) * this.pageSize + index + 1;
        },
        sizeChangeHandle(val) {
          this.queryData.rows = val;
          this.getSendList();
        },
        currentChangeHandle (val) {
          this.queryData.page = val;
          this.getSendList();
        },

        routerAdd(){
            removeTabHandle('synthesize_superviseAndHandle_sendForm')
            this.$router.push({
                name:'synthesize_superviseAndHandle_sendForm',
                // params:{
                //     ids: ['0f5884140d53413d9ca592584b4228e5', '504e7242d3f94a58be36410220387282', '5531bc1d7844467d87099ab73cdfcd75'],
                // }
            })

        },

        viewDetail (row){ // 跳转详情
            console.log(row);
            removeTabHandle('synthesize_superviseAndHandle_sendView')
            removeTabHandle('synthesize_superviseAndHandle_sendEdit')

            if (row.status == -1) {
                this.$router.push({
                  name:'synthesize_superviseAndHandle_sendEdit',
                  query:{
                    id: row.id
                  }
                })
            } else {
                this.$router.push({
                  name:'synthesize_superviseAndHandle_sendView',
                  query:{
                    id: row.id,
                    active: 'sent'
                  }
                })
            }


        },

		/* *********************** 逻辑处理 *********************** */

        // 重置搜索对象
        resetData () {
            this.queryData = {
                page: 1,
                rows: 10,
                orderBy: '',
                searchKey: '',
                filter: {
                    searchType:0,
                    tradeId:'',
                },
            };
        },

        // 撤回操作
        withdrawHandler (row) {
            console.log(row);
            this.$confirm('确定撤回本条已发送的督办吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.withdraw(row.id)
            }).catch(() => {
            });
        },

        // 删除操作
        deleteHandler (row) {
            console.log(row);
            this.$confirm('确定删除本条督办吗？删除后的督办将无法恢复！', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.delete(row.id)
            }).catch(() => {
            });
        },

        // 筛选
        filterChange (val) {
            if (val.statusCondition && val.statusCondition.length>0) {
                this.queryData.filter.statusCondition = val.statusCondition.join(',');
            } else {
                this.queryData.filter.statusCondition = '';
            }
            if (val.replyStatusCondition && val.replyStatusCondition.length>0) {
                this.queryData.filter.replyStatusCondition = val.replyStatusCondition.join(',');
            } else {
                this.queryData.filter.replyStatusCondition = '';
            }

            this.getSendList();
        },
        filterHandler () {
            this.getSendList();
            document.querySelector(".table-body").click();
        },

        cancelFilter () {
            document.querySelector(".table-body").click();
        },

        // 排序
        sortChange (val) {
            console.log(val);
            switch (val.order) {
                case 'descending': this.queryData.orderBy = val.prop + ' desc'; break;
                case 'ascending': this.queryData.orderBy = val.prop + ' asc'; break;
                default: this.queryData.orderBy = '';
            }
            this.getSendList();
        },

		/* *********************** 接口调用 *********************** */

        // 获取列表数据
        getSendList (parentObj) {
            this.queryData.searchKey=parentObj?parentObj.searchKey:this.keyword
            this.queryData.filter.superviseDeptCodeList=parentObj?parentObj.superviseDeptCodeList:this.uerdefultOptionCode
            this.dataListLoading = true;
            this.$httpReq.post('/application/inspector/list', {
                ...this.queryData
            }).then(({data}) => {
                console.log(data);
                this.sendList = data.rows;
                this.total = data.total;
                this.dataListLoading = false;
                if (this.keyword) {
                    this.$emit('findDataNumber', this.total)
                }
            })
        },

        // 获取列表数据
        withdraw (id) {
            this.dataListLoading = true;
            this.$httpReq.post('/application/inspector/withdraw', {
                id: id
            }).then(({data}) => {
                console.log(data);
                this.dataListLoading = false;

                if (data.code == '1') {
                    this.$message({
                        type: 'success',
                        message: '撤回成功!'
                    });
                    this.getSendList();
                } else {
                    this.$message({
                        type: 'error',
                        message: data.msg
                    });
                }
            })
        },

        // 删除
        delete (id) {
            this.dataListLoading = true;
            this.$httpReq.post('/application/inspector/delete', {
                id: id
            }).then(({data}) => {
                console.log(data);
                this.dataListLoading = false;

                if (data.code == '1') {
                    this.$message({
                        type: 'success',
                        message: '删除成功!'
                    });
                    this.getSendList();
                } else {
                    this.$message({
                        type: 'error',
                        message: data.msg
                    });
                }
            })
        },

    },
};
</script>

<style lang="scss" scoped>
    .table-body{
        // margin:16px 24px;
        background: #ffffff;
        // padding: 15px 24px;
        margin-bottom: 0;
        .opt-btn{
            // margin-bottom:16px;
            padding: 16px;
        }
    }

.custom-header {
    display: flex;
    justify-content: left;
    line-height: 25px;
    margin-top: 5px;
    padding-left: 0;
    i {
        margin-left: 10px;
        cursor: pointer;
        &:hover {
            opacity: .8;
        }
    }
}
.custom-section {
    padding: 20px;
    .custom-section--btns {
        text-align: right;
        margin-top: 20px;
    }
}
.row-overflow {
    overflow: hidden;
	text-overflow: ellipsis;
	display: -webkit-box;
	-webkit-box-orient: vertical;
	-webkit-line-clamp: 2;
}
</style>
